import React, { useEffect, useState } from "react";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import api from "../api";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const GenAdminDept = () => {
  const { i18n, t } = useTranslation();
  const [genDepartments, setGenDepartments] = useState([]);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);

  const fetchDeptData = async () => {
    try {
      const response = await api.get(`/public_disclosure?lang=${i18n.language}`);
      const filteredDepartments = response.data.filter(
        (department) =>
          department.status === 1 &&
          department.language_code === i18n.language
      );
      setDepartments(filteredDepartments);
    } catch (error) {
      console.error("Error fetching department data:", error);
    }
  };

  useEffect(() => {
    fetchDeptData();
  }, [i18n.language]);

  useEffect(() => {
    const fetchGenDepartments = async () => {
      try {
        const response = await api.get(`/generaladmindepartment?lang=${i18n.language}`);
        const filteredDepartments = response.data.filter(
          (department) =>
            department.status === 1 &&
            department.language_code === i18n.language
        );
        setGenDepartments(filteredDepartments);
      } catch (err) {
        setError(
          err.response
            ? err.response.data.message
            : "Error fetching departments"
        );
      }
    };
    fetchGenDepartments();
  }, [i18n.language]);

  return (
    <div>
      <section className="page-title ">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${innerBanner})`,
          }}
        ></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{t("generalAdminDepartment")}</h1>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/departments">{t("departments")}</Link>
              </li>
              <li>
                <span>{t("generalAdminDepartment")}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <div id="main-content">
      <br />
      <section className="departments-style-two alternat-2">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-9 col-md-12 col-sm-12 content-side">
              <div className="department-details-content">
                <div className="content-one dept_leyer_1">
                  <div className="title-box">
                    <h3>{t("generalAdminDepartment")}</h3>
                    <hr />
                  </div>
                  <ul>
                    {error ? (
                      <li>{error}</li>
                    ) : (
                      genDepartments.map((dept) => (
                        <li key={dept.id}>
                          <Link to={dept.heading_link} state={{ id: dept?.p_id }}>
                            {dept.department_heading}
                          </Link>
                        </li>
                      ))
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-12 sidebar-side">
              <div className="department-sidebar">
                <div className="category-widget">
                  <div className="widget-content">
                    <ul className="category-list clearfix">
                      {departments.map((department, index) => (
                        <li key={index}>
                          {" "}
                          <Link
                            to={
                              department?.department_name === "General Admin Department" || department?.department_name === "सामान्य प्रशासन विभाग"
                                ? "/general-admin-department"
                                  : `${department?.department_link}`
                            }
                            state={{ id: department?.p_id }}
                          >
                            {department?.department_name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
    </div>
  );
};

export default GenAdminDept;